import { useContext, useEffect, useState } from 'react';
import InputTextBox from '../../constants/InputTextBox';
import { Button } from '../../constants/Button';
import { GiWaterSplash } from "react-icons/gi";
import DefaultSelectInputBox from '../../constants/DefaultSelectBox';
import { BranchOptions } from '../../constants/Options';
import AuthContext from '../../context/AuthContext';
interface SelectValues {
    branch_id: string;
}
const LoginPageView = () => {
    const { loginUser, authTokens } = useContext(AuthContext) || {}; // Get loginUser and authTokens together

    const [selectValues, setSelectValues] = useState<SelectValues>({
        branch_id: "1",
    });
    const optionHandleSelect = (fieldName: string, data: string | number) => {
        setSelectValues(prevValues => ({
            ...prevValues,
            [fieldName]: data,
        }));
    };

    return (
        <section className="bg-gray-100 dark:bg-gray-900 h-screen">
            <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
                <div className="w-full dark:border md:mt-0 sm:max-w-[45rem] xl:p-0 dark:bg-gray-800 dark:border-gray-700">
                    <div className="space-y-3 md:space-y-5">
                        <div className="sm:flex block rounded-md bg-slate-100 sm:shadow-xl">
                            <div className="flex-1 sm:p-5 sm:flex justify-center items-center sm:bg-gradient-to-br sm:from-gray-50 sm:to-gray-400 sm:bg-transparent rounded-l-md">
                                <div className="text-center w-full">
                                    <GiWaterSplash size={70} className="mx-auto text-green-800" />
                                    <h1 className='font-public-sans font-bold text-green-800 uppercase text-3xl -mt-1'>H20</h1>
                                </div>
                            </div>
                            <div className="sm:bg-white bg-transparent flex-1 p-5 sm:py-14">
                                <h1 className="text-2xl font-condensed font-bold select-none">Login</h1>
                                <p className="text-[10px] font-public-sans select-none font-medium mb-2 text-gray-800">
                                    Please provide your valid login details to get access.
                                </p>
                                <form onSubmit={loginUser}>
                                    <div className="mt-8 space-y-3">
                                        <InputTextBox type='text'
                                            login={true}
                                            name="username"
                                            placeholder="Enter your Username"
                                            required={true}
                                        />
                                        <InputTextBox
                                            type='password'
                                            login={true}
                                            name="password"
                                            placeholder="Enter your Password"
                                            required={true}
                                        />
                                        <DefaultSelectInputBox
                                            login={true}
                                            name="branch_id"
                                            disabled={true}
                                            options={BranchOptions}
                                            value={selectValues.branch_id}
                                            optionSelect={optionHandleSelect}
                                            clear={true}
                                            placeholder="Select Branch"
                                        />
                                    </div>
                                    <div className="text-[10px] mt-2 flex justify-end">
                                        <span className="font-normal text-green-600 transition-colors duration-300 delay-200 hover:text-green-700 hover:underline hover:transition-all hover:delay-300 cursor-pointer">
                                            Renew License
                                        </span>
                                    </div>
                                    <div className="mt-8 flex justify-center">
                                        <Button type='submit' el='button' btn_type='login'>
                                            Login
                                        </Button>
                                    </div>
                                </form>
                                <div className="mt-6 text-center">
                                    <p className="text-[11px] font-public-sans font-normal">
                                        Licensed to: <span className="text-green-600 font-condensed">Preface Technology PVT LTD</span>
                                    </p>
                                    <p className="text-[11px] font-public-sans font-normal">
                                        Copyright © 2023. <span className="text-green-600 font-condensed">Preface Technology PVT LTD</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default LoginPageView;
